import constants from "../constants";

export const initialState = {
    theme: {
        mode: constants.themeModes.light
    }
};

export const theme = initialState.theme;